// La grille HEART, au tableau d'adoption : ce qui se passe, lettre par lettre. Elle
// ne fait pas de score : elle montre les mesures, leur écart au relevé précédent
// et leur source. Une lettre vide dit quoi brancher, jamais zéro.
import { Chip, Eyebrow } from '../components/ui';
import { useHeart } from './measures';

const fr = (n: number) => n.toLocaleString('fr-FR');

export function HeartGrid({ projectId }: { projectId: string }) {
  const heart = useHeart(projectId);
  if (heart.isPending || heart.isError) return null;

  return (
    <section className="metrics">
      <div className="metrics-head">
        <Eyebrow>HEART</Eyebrow>
        <h2 className="t-h2">Ce qui se passe</h2>
      </div>
      <ul className="heart-grid">
        {heart.data.letters.map((l) => (
          <li key={l.letter} className="zy-card">
            <p className="heart-title">
              <span className="heart-letter" aria-hidden="true">{l.letter}</span>
              {l.label}
            </p>
            {l.items.length === 0 ? (
              <p className="zy-texte-muet">{l.hint}</p>
            ) : (
              <ul className="heart-items">
                {l.items.map((m) => (
                  <li key={m.key} className="zy-stat">
                    <span className="zy-texte-muet">{m.name}</span>
                    <span className="zy-stat__valeur">
                      {fr(m.value)}{m.unit ? <small>{m.unit}</small> : null}
                    </span>
                    <span className="zy-texte-muet">
                      {m.change ? `${m.change.label}, ` : ''}{m.source}
                    </span>
                    {m.outOfScore ? <Chip>Hors score</Chip> : null}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
